<template>
  <div
    v-if="terminalPaymentProcessing"
    class="square-terminal-cancel-payment-request"
    data-cy="cancel-terminal-payment-request"
    :disabled="disabled"
    @click="cancelPaymentRequest"
  >
    <div class="wrapper">
      <font-awesome-icon
        icon="ban"
        size="4x"
      />
      <div class="cancel-label">
        <slot>
          Cancel payment request
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stripe-terminal-cancel-payment-request',
  data: function() {
    return {
      disabled: false
    }
  },
  computed: {
    terminalPaymentProcessing: function() {
      return this.$store.getters['square/terminalPaymentPending']
    }
  },
  methods: {
    cancelPaymentRequest: function() {
      this.disabled = true
      this.$store.dispatch('square/cancelTerminalPaymentRequest')
        .then(cancelResponse => {
          this.$emit('cancelled', {
            status: true,
            response: cancelResponse
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .square-terminal-cancel-payment-request {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 1.5rem; // Added padding around the entire component

    .cancel-label {
      margin-top: 1.2rem;
      text-align: center;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;

      max-width: fit-content;
      border: 1px solid black;
      cursor: pointer;
      padding: 2.2rem 1.2rem;
      margin: 0 auto;
    }
  }

</style>
